// components/pricing/SingleSessionPricing/styles.js
import styled from 'styled-components';

export const PackageGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: ${props => props.theme.spacing.xl};
    margin: ${props => props.theme.spacing['3xl']} 0;

    @media (max-width: ${props => props.theme.breakpoints.md}) {
        grid-template-columns: 1fr;
        padding: 0 ${props => props.theme.spacing.md};
    }
`;

export const PackageCard = styled.div`
    background: white;
    border-radius: ${props => props.theme.borderRadius.lg};
    padding: ${props => props.theme.spacing.xxl};
    box-shadow: ${props => props.theme.shadows.md};
    display: flex;
    flex-direction: column;
    transition: transform ${props => props.theme.transitions.normal};

    &:hover {
        transform: translateY(-4px);
    }

    button {
        margin-top: auto;
    }
`;

export const PackageHeader = styled.div`
    text-align: center;
    margin-bottom: ${props => props.theme.spacing.xl};
    
    h3 {
        font-size: ${props => props.theme.typography.sizes['2xl']};
        color: ${props => props.theme.colors.text.primary};
        margin-bottom: ${props => props.theme.spacing.sm};
    }

    .duration {
        color: ${props => props.theme.colors.text.secondary};
        margin-top: ${props => props.theme.spacing.sm};
    }
`;

export const Price = styled.div`
    margin: ${props => props.theme.spacing.lg} 0;
    
    .currency {
        font-size: ${props => props.theme.typography.sizes.xl};
        color: ${props => props.theme.colors.text.primary};
        margin-right: ${props => props.theme.spacing.xs};
    }

    .amount {
        font-size: ${props => props.theme.typography.sizes['4xl']};
        font-weight: ${props => props.theme.typography.weights.bold};
        color: ${props => props.theme.colors.text.primary};
    }
`;

export const FeatureList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0 0 ${props => props.theme.spacing.xl};
`;

export const Feature = styled.li`
    display: flex;
    align-items: center;
    gap: ${props => props.theme.spacing.sm};
    margin-bottom: ${props => props.theme.spacing.md};
    color: ${props => props.theme.colors.text.secondary};

    svg {
        color: ${props => props.theme.colors.success.main};
        flex-shrink: 0;
    }
`;

export const PackageType = styled.span`
    display: inline-block;
    padding: ${props => props.theme.spacing.xs} ${props => props.theme.spacing.sm};
    border-radius: ${props => props.theme.borderRadius.full};
    font-size: ${props => props.theme.typography.sizes.sm};
    font-weight: ${props => props.theme.typography.weights.medium};
    
    ${props => props.type === 'newborn' ? `
        background: ${props.theme.colors.primary.main}20;
        color: ${props.theme.colors.primary.main};
    ` : `
        background: ${props.theme.colors.success.main}20;
        color: ${props.theme.colors.success.main};
    `}
`;